import { getLocalStorage, removeLocalStorage, removeSessionStorage, setLocalStorage } from "@/utils/storage";
const IMPERSONATOR_EMAIL_KEY = "impersonatorAdminUserEmail";
const IMPERSONATOR_WRITE_FLAGS_KEY = "impersonatorAdminUserWriteFlags";
/** Legacy sessionStorage keys — cleared on end/login so pre-migration sessions don't linger. */
const LEGACY_SESSION_EMAIL_KEY = "impersonatorAdminUserEmail";
const LEGACY_SESSION_CONFIG_PERM_KEY = "impersonatorAdminUserConfigPerm";
const WRITE_FLAG_KEYS = [
    "AbpIdentity.Users.Impersonation",
    "AbpIdentity.Users.Impersonation.Write",
    "AbpIdentity.Users.AdminImpersonation",
    "AbpIdentity.Users.AdminImpersonation.Write",
];
const pickWriteFlags = (configPerm) => {
    const flags = {};
    WRITE_FLAG_KEYS.forEach(key => {
        if (configPerm[key]) {
            flags[key] = true;
        }
    });
    return flags;
};
export const getImpersonatorAdminUserEmail = () => {
    const email = getLocalStorage(IMPERSONATOR_EMAIL_KEY);
    return typeof email === "string" ? email : null;
};
export const getImpersonatorWriteFlags = () => {
    const flags = getLocalStorage(IMPERSONATOR_WRITE_FLAGS_KEY);
    if (flags && typeof flags === "object") {
        return flags;
    }
    return {};
};
/**
 * Prefer localStorage email (set on Start Impersonation, shared across tabs).
 * Pass configCurrentUser when available so impersonatorUserId still covers edge cases
 * (e.g. ConsentModal in BasicLayout) without reading the dva store directly.
 */
export const isImpersonating = (configCurrentUser) => getImpersonatorAdminUserEmail() !== null || configCurrentUser?.impersonatorUserId != null;
export const canPerformImpersonationWrite = () => {
    const flags = getImpersonatorWriteFlags();
    const canPerformUserWriteAction = !!flags["AbpIdentity.Users.Impersonation"] && !!flags["AbpIdentity.Users.Impersonation.Write"];
    const canPerformAdminUserWriteAction = !!flags["AbpIdentity.Users.AdminImpersonation"] && !!flags["AbpIdentity.Users.AdminImpersonation.Write"];
    return canPerformUserWriteAction || canPerformAdminUserWriteAction;
};
/** Same rules as the request interceptor write block (kept here for unit testing). */
export const shouldBlockWriteWhileImpersonating = (method, url) => {
    const isTryingToImpersonate = url.endsWith("/connect/token");
    return !isTryingToImpersonate && method !== "get" && isImpersonating() && !canPerformImpersonationWrite();
};
export const setImpersonationMetadata = (email, configPerm) => {
    setLocalStorage(IMPERSONATOR_EMAIL_KEY, email);
    setLocalStorage(IMPERSONATOR_WRITE_FLAGS_KEY, pickWriteFlags(configPerm));
};
export const clearImpersonationMetadata = () => {
    removeLocalStorage(IMPERSONATOR_EMAIL_KEY);
    removeLocalStorage(IMPERSONATOR_WRITE_FLAGS_KEY);
    // Clear leftover sessionStorage keys from before the localStorage migration
    removeSessionStorage(LEGACY_SESSION_EMAIL_KEY);
    removeSessionStorage(LEGACY_SESSION_CONFIG_PERM_KEY);
};
